import React from 'react'
import { LocaleContext } from '../../context/locale'
import config from 'config'
import { FetchErrorMessage } from 'components/fetchErrorMessage'
import { ArticleTeasers, SortMode } from '@ta-interaktiv/react-article-teasers'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import de from 'locales/de.yml'
import fr from 'locales/fr.yml'

const STRINGS = {
  de: de,
  fr: fr
}

export class AutomaticArticleTeasers extends React.Component {
  static contextType = LocaleContext
  static tenants = require('../../data/tenants.csv')
  /**
   * @param {any} props
   * @param {any} context
   */
  constructor(props, context) {
    super(props, context)
    this.state = {
      articleIds: null,
      errorMessage: null,
      articleDomain: parseHostname().publicationName
    }
    // console.log('automaticarticleteasers was constructed')
  }

  /**
   * Retrieves processed texts from initial wordsmith templates
   * @param {string} kt Cantonal short name
   * @param {string} locale
   * @param {string | null} feedId
   */
  getRelatedArticles(kt, locale, feedId) {
    const BASE_URL = config.apiBaseUrl
    const API_ENDPOINT = '/api/ccu/get_related_articles/'
    const endpoint = new URL(API_ENDPOINT + kt + '/' + feedId, BASE_URL)
    endpoint.searchParams.append('lang', locale)
    const url = endpoint

    return window
      .fetch(url.href, {
        method: 'GET',
        mode: 'cors',
        cache: 'no-cache',
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      })
      .then(response => {
        if (response.ok) {
          return response.json()
        }
        throw new Error(response.status + ': ' + response.statusText)
      })
  }

  /**
   * @param {{ message: any; }} error
   */
  handleError(error) {
    console.log(error)
    this.setState({ errorMessage: error.message })
    // console.group('Fetch autotext')
    // console.warn('Cantonal situation could not be loaded:')
    // console.warn(error)
    // console.groupEnd()
  }

  handleCantonDomainRelationship() {
    const actualDomain = parseHostname().publicationName // 'zsz'
    let domain = actualDomain
    if (this.props.kt === 'BE') {
      domain = ![
        'bernerzeitung',
        'derbund',
        'berneroberlaender',
        'langenthalertagblatt',
        'thunertagblatt'
      ].includes(actualDomain)
        ? 'bernerzeitung'
        : actualDomain // TODO: add random change between derbund and bernerzeitung
    } else if (this.props.kt === 'ZH') {
      domain = !['tagesanzeiger', 'zsz', 'zuonline', 'landbote'].includes(
        actualDomain
      )
        ? 'tagesanzeiger'
        : actualDomain
    } else if (this.props.kt === 'BL' || this.props.kt === 'BS') {
      domain = !['bazonline'].includes(actualDomain)
        ? 'bazonline'
        : actualDomain
    } else if (this.props.kt === 'VD') {
      domain = !['24heures'].includes(actualDomain) ? '24heures' : actualDomain
    } else if (this.props.kt === 'GE') {
      domain = !['tdg'].includes(actualDomain) ? 'tdg' : actualDomain
    }
    // special cases for other cantons whevener implemented
    else {
      domain = 'tagesanzeiger' // FIXME probably best to show only mantel articles
    }
    return domain
  }

  getFeedId(domain) {
    return AutomaticArticleTeasers.tenants.filter(
      o => o.domain === (domain || parseHostname().publicationName)
    )[0].feedId
  }

  getAndParseRelatedArticles(feedId) {
    this.getRelatedArticles(this.props.kt, this.context, feedId)
      .then(data => {
        // trigger state change
        this.setState({
          articleIds: data.articles,
          errorMessage: null,
          articleDomain: data.domain
        })
      })
      .catch(e => this.handleError(e))
  }

  componentDidMount() {
    // console.log('automaticarticleteasers did mount')
    // get the current feed id, then fetch the related articles for that feed id
    const domain = this.handleCantonDomainRelationship()
    this.getAndParseRelatedArticles(this.getFeedId(domain))
  }

  /**
   * @param {{ kt: any; }} prevProps
   */
  componentDidUpdate(prevProps) {
    // console.log('automaticarticleteasers did update')
    // Typical usage (don't forget to compare props):
    // update because another KT was chosen
    if (this.props.kt !== prevProps.kt) {
      const domain = this.handleCantonDomainRelationship()
      this.getAndParseRelatedArticles(this.getFeedId(domain))
    }
  }

  render() {
    const localization = STRINGS[this.context]

    // Setup content for the default case
    let Content = (
      <>
        {/* situation is HTML, so should be rendered accordingly */}
        {this.state.articleIds && this.state.articleIds.length > 0 && (
          <>
            <ArticleTeasers
              sorting={SortMode.REVERSE_CHRONOLOGICALLY_BY_CREATION_DATE}
              numberOfCards='three'
              forceDomain={this.state.articleDomain}
              articleIds={this.state.articleIds}
            />
          </>
        )}
        {!this.state.articleIds && (
          <div className='ui placeholder'>
            {localization.contentLoadingMessage}
          </div>
        )}
        {this.state.articleIds && this.state.articleIds.length < 1 && (
          <>{/* show nothing */}</>
        )}
      </>
    )

    // show something else in case of an error
    if (this.state.errorMessage) {
      Content = (
        <div className='ui text container'>
          <FetchErrorMessage status={this.state.errorMessage ?? ''} />
        </div>
      )
    }

    return <div>{Content}</div>
  }
}
